import styled from 'styled-components';

import placeApi from '@src/services/api/place';
import { RequestBookingListType } from '@src/types/booking';
import { useEffect, useMemo, useRef, useState } from 'react';
import RequestListTable from './table';
import Input from '@src/components/ui/atoms/input';
import Button from '@src/components/ui/atoms/button';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { Tabs } from '@mui/material';
import RequestCard from './card';

export const Container = styled.div`
  .blank {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  }
`;

export const InfoWrap = styled.div`
  padding: 10px 0;
  display: flex;
  gap: 20px;
  > div {
    flex: 1;
  }
`;

const TAB_LIST = [
  {
    key: 0,
    label: '신청',
  },
  {
    label: '승인',
    key: 1,
  },
  {
    label: '거절',
    key: 2,
  },
];

type TabType = (typeof TAB_LIST)[number]['key'];

interface TabPanelProps {
  children?: React.ReactNode;
  value: TabType;
  selected: TabType;
}

function TabPanel(props: TabPanelProps) {
  const { children, selected, value } = props;

  return (
    <div
      role="tabpanel"
      hidden={selected !== value}
      id={`simple-tabpanel-${value}`}
      aria-labelledby={`simple-tab-${value}`}
    >
      {value === selected && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function RequestScheduleList() {
  const [requestAllList, setRequestAllList] = useState<RequestBookingListType[]>();
  const [tab, setTab] = useState<TabType>(0);
  const selectedIdList = useRef<number[]>([]);
  const [cookie, setCookie] = useState('');
  async function getScheduleList() {
    const { data } = await placeApi.getRequestList();
    setRequestAllList(data);
  }
  const requestList = useMemo(() => requestAllList?.filter(request => request.confirm === tab), [requestAllList, tab]);

  const handleSetCookie = async () => {
    if (!cookie) {
      return;
    }
    try {
      if (!selectedIdList.current.length) {
        return;
      }
      const { data } = await placeApi.setCookie(selectedIdList.current, cookie);
      setRequestAllList(data);
    } catch (error) {
      alert(error);
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setTab(newValue);
  };
  const deleteRequest = async (id: number) => {
    try {
      const { data } = await placeApi.deleteRequest([id]);
      console.log('delete');
      getScheduleList();
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    getScheduleList();
  }, []);

  return (
    <Container>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={handleTabChange} aria-label="lab API tabs example">
          {TAB_LIST.map(tab => (
            <Tab key={tab.key} value={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      {/* <TabPanel value={0} selected={tab}> */}
      {requestList?.map(request => <RequestCard key={request.id} request={request} deleteRequest={deleteRequest} />)}
      {requestList?.length ? '' : <div className="blank">목록이 없습니다</div>}
      {/* </TabPanel> */}
      {/* <TabPanel value={1} selected={tab}>
        Item Two
      </TabPanel>
      <TabPanel value={2} selected={tab}>
        Item Three
      </TabPanel> */}
    </Container>
  );
}
